import {FC, useEffect} from 'react'
import {errorHandler} from '@utilities/helpers.ts'
import {useChatbotStore} from '@/features/chatbot/store/chatbotStore.ts'
import {ChatbotReason, ChatbotStep} from '@/features/chatbot/types.ts'
import {httpSubmitTicket} from '@/features/chatbot/services/submitTicket.http.ts'
import {useTranslation} from 'react-i18next'
import {defineTicketInfoByReason} from '@features/chatbot/helpers.ts'

interface TicketSubmitProps {
    reason: ChatbotReason
    isInShootPage?: boolean
    isNotListed?: boolean
}

const TicketSubmit: FC<TicketSubmitProps> = ({reason, isInShootPage = false, isNotListed = false}) => {
    const assignment = useChatbotStore(state => state.assignment)
    const selectedAssignment = useChatbotStore(state => state.selectedAssignment)
    const chatHistory = useChatbotStore(state => state.chatHistory)
    const chatbotRef = useChatbotStore(state => state.chatbotRef)
    const recap = chatHistory.map(({message}) => message).join(' --- ')
    const {t} = useTranslation()

    useEffect(() => {
        onSendTicketResults()
    }, [])

    const onSendTicketResults = async () => {
        const renderedSteps = (chatbotRef?.current as {state?: {renderedSteps?: ChatbotStep[]}})?.state?.renderedSteps
        const shoot = selectedAssignment ?? assignment

        try {
            await httpSubmitTicket({
                entityId: shoot?.entity?.id,
                shootMediaId: shoot?.task_media?.id ? String(shoot.task_media.id) : undefined,
                data: {
                    ...defineTicketInfoByReason({
                        reason,
                        isInShootPage,
                        shoot,
                        steps: renderedSteps || [],
                        isNotListed
                    }),
                    recap
                }
            })
        } catch (e) {
            errorHandler(e)
        }
    }

    return <p>{t('chatbot:ticket_submit:message')}</p>
}

export default TicketSubmit
